// extracted by mini-css-extract-plugin
export default {"collapse":"Collapse_collapse__G4wZ+","header":"Collapse_header__1h7Bv","title":"Collapse_title__zSAGp","icon":"Collapse_icon__5fD8T"};